module.exports = __webpack_public_path__ + "img/securityImg7.8050d8bc.png";